import { Component, EventEmitter, Injectable, Input, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const WEEKDAYS_AR = ['أح', 'إث', 'ثلا', 'أر', 'خم', 'جم', 'سب'];
const WEEKDAYS_EN = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
const MONTHS_AR = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];
const MONTHS_EN = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const language = localStorage.getItem('language') || 'en';
const MONTHS = language === 'en' ? MONTHS_EN : MONTHS_AR;
const WEEKDAYS = language === 'en' ? WEEKDAYS_EN : WEEKDAYS_AR;

@Injectable()
export class ArabicI18n extends NgbDatepickerI18n {
  getMonthShortName(month: number) {
    return MONTHS[month - 1];
  }

  getMonthFullName(month: number) {
    return MONTHS[month - 1];
  }

  getWeekdayLabel(weekday: number) {
    return WEEKDAYS[weekday - 1];
  }
  getWeekdayShortName(weekday: number) {
    return WEEKDAYS[weekday - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Component({
  selector: 'app-ngb-datepicker',
  standalone: false,
  templateUrl: './ngb-datepicker.component.html',
  providers: [
    {provide: NgbDatepickerI18n, useClass: ArabicI18n}
  ]
})
export class NgbDatepickerComponent {
  lang = localStorage.getItem('language') || 'ar';
  @Input() label: string = 'form.Date';
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() controlName!: string;
  @Input() isSubmitted!: boolean;
  @Input() required!: boolean;
  @Input() disabled!: boolean;
  @Input() min: any; // Date or NgbDateStruct
  @Input() max: any; // Date or NgbDateStruct
  @Input() invalidMsg!: string;
  @Input() showToday = true;
  @Input() isView = false;
  @Input() placement: string = 'auto';
  @Input() selectedDate!: any; //NgbDateStruct
  @Input() noIcon: boolean = true;

  @Output() selectedDateChanged = new EventEmitter<any>();
  @Output() ageValue = new EventEmitter<any>();

  today!: any;
  isTouched = false;
  minDate!: NgbDateStruct;
  maxDate!: NgbDateStruct;

  constructor(
    private calendar: NgbCalendar
  ) {
    this.today = this.calendar.getToday();
  }

  ngOnInit(): void {
    if (!this.min) { this.min = new Date('1/1/1938'); }
    if (this.max) { this.max = new Date(this.max); }
    this.setMinMax();

    if (this.controlName && this.formGroup.controls[this.controlName].value) {
      this.selectedDate = this.tongbDate(this.formGroup.controls[this.controlName].value);
    }
    if (this.selectedDate) {
      this.selectedDate = this.tongbDate(this.selectedDate);
      this.setFieldControlValue();
    } else {
      // this.selectedDate = new DateStruct();
    }
    if (this.controlName) {
      this.formGroup.controls[this.controlName].valueChanges.subscribe(value => {
        this.selectedDate = this.tongbDate(value);
        console.log(this.selectedDate);

      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setMinMax();
    this.ckechValid();
  }

  setMinMax(min = this.min, max = this.max) {
    this.minDate = this.tongbDate(min);
    this.maxDate = this.tongbDate(max);
  }

  tongbDate(date: any) {
    if (typeof (date) === 'string') { date = new Date(date); }
    if (date instanceof Date && date.getTime()) {
      return { day: date.getDate(), month: date.getMonth() + 1, year: date.getFullYear() };
    } else {
      return date;
    }
  }
  setFieldControlValue() {
    // yyyy-MM-dd
    let date = null;
    if (this.selectedDate) {
      date = this.selectedDate.year + '/' + this.selectedDate.month + '/' + this.selectedDate.day;
    }
    if (this.controlName) {
      this.formGroup.controls[this.controlName].setValue(date);
    }
    this.selectedDateChanged.emit(date);
  }
  setDate(selected: any = null) {
    this.selectedDate = selected;
    this.setFieldControlValue();
  }
  ckechValid() {
    // let ctrVal = this.formGroup.controls[this.controlName].value;
    let ctrVal = this.selectedDate;
    if (ctrVal) {
      const date = new NgbDate(ctrVal.year, ctrVal.month, ctrVal.day);
      if (date.before(this.minDate) || date.after(this.maxDate)) {
        this.formGroup.controls[this.controlName].setErrors({invalid: true});
      } else {
        this.formGroup.controls[this.controlName].setErrors(null);
      }
    }
  }
  hasError(errorName: string | null = null) {
    if (this.isSubmitted || this.isTouched) {
      let control = this.formGroup.controls[this.controlName];
      if (this.controlName) {
        if (!errorName) { return control.invalid; }
        else { return control.hasError(errorName); }
      }
      else { return !this.selectedDate; }
    }
    return false;
  }
}
